import { ChangeDetectionStrategy, Component, forwardRef, inject, OnChanges, OnInit } from '@angular/core';
import { Mask, ComponentsModule } from '../../../../../lib';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SlotComponent } from '../slot.component';
import { MaskMapper } from '../../../services';
import { BlockParameterType } from '../../../interfaces';
import { TranslationKeyPipe, SlotTooltipPipe } from '../../../pipes';
import { parseNGXMaskToNumber } from '../../../utils';
import { VisualComponent } from '../../visual/visual.component';

@Component({
    selector: 'ca-slot-input',
    imports: [ComponentsModule, SlotTooltipPipe, TranslationKeyPipe, VisualComponent],
    templateUrl: './slot-input.component.html',
    styleUrl: './slot-input.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SlotInputComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlotInputComponent extends SlotComponent implements OnInit, OnChanges {
    mask: Mask;
    private maskMapper = inject(MaskMapper);

    override ngOnInit() {
        setTimeout(() => {
            this.control.setValue(this.value());
        });
        super.ngOnInit();
    }

    override ngOnChanges() {
        this.mask = this.maskMapper.fromSlotToMask(this.slot());
    }

    override writeValue(value: any): void {
        this.value.set(value);
    }

    onValueChange(value: any) {
        if (!this.isDisabled) {
            if (this.slot()?.outputParameterType === BlockParameterType.Number) {
                value = parseNGXMaskToNumber(value);
            }
            if (value === '') {
                value = null;
            }

            this.value.set(value);
            this.onChange(value);
        }
    }
}
